import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);

    const handleLogout = () => {
        logout();
        navigate('/');
        setMenuOpen(false);
    };

    const isActive = (path) => location.pathname === path;

    return (
        <nav style={{ background: '#1a1a2e' }} className="shadow-lg sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between" style={{ height: '96px' }}>
                    {/* Logo */}
                    <Link to="/" className="flex items-center text-white no-underline">
                        <div className="flex-shrink-0" style={{ width: '88px', height: '88px' }}>
                            <img src="/logo.png" alt="SellerSource" style={{ width: '62px', height: '62px', objectFit: 'contain' }} />
                        </div>
                    </Link>

                    {/* Desktop nav */}
                    <div className="hidden md:flex items-center gap-1">
                        <Link to="/" className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${isActive('/') ? 'text-white bg-white/10' : 'text-gray-300 hover:text-white hover:bg-white/5'}`}>
                            Home
                        </Link>
                        <Link to="/pricing" className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${isActive('/pricing') ? 'text-white bg-white/10' : 'text-gray-300 hover:text-white hover:bg-white/5'}`}>
                            Pricing
                        </Link>
                        {user ? (
                            <>
                                <Link to="/dashboard" className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${isActive('/dashboard') ? 'text-white bg-white/10' : 'text-gray-300 hover:text-white hover:bg-white/5'}`}>
                                    Dashboard
                                </Link>
                                <Link to="/reports" className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${isActive('/reports') ? 'text-white bg-white/10' : 'text-gray-300 hover:text-white hover:bg-white/5'}`}>
                                    My Reports
                                </Link>
                                {user.email === 'boookssales@gmail.com' && (
                                    <Link to="/admin" className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-colors ${isActive('/admin') ? 'text-white' : 'text-white/80 hover:text-white'}`}
                                        style={{ background: '#e94560' }}>
                                        <i className="fas fa-shield-alt mr-1"></i> Admin
                                    </Link>
                                )}
                                <div className="flex items-center gap-2 ml-3 pl-3 border-l border-white/20">
                                    <div className="w-8 h-8 rounded-full flex items-center justify-content-center" style={{ background: '#e94560' }}>
                                        <span className="text-white font-bold text-xs flex items-center justify-center w-full h-full">
                                            {(user.name || user.email || '?')[0].toUpperCase()}
                                        </span>
                                    </div>
                                    <span className="text-gray-300 text-sm hidden lg:block">{user.name || user.email}</span>
                                    <button onClick={handleLogout}
                                        className="ml-1 px-3 py-1.5 text-sm font-medium text-gray-300 hover:text-white border border-white/20 hover:border-white/40 rounded-lg transition-colors">
                                        Logout
                                    </button>
                                </div>
                            </>
                        ) : (
                            <div className="flex items-center gap-2 ml-3">
                                <Link to="/login" className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white transition-colors">
                                    Login
                                </Link>
                                <Link to="/register" className="px-4 py-2 text-sm font-semibold text-white rounded-lg transition-all hover:opacity-90"
                                    style={{ background: '#e94560' }}>
                                    Sign Up Free
                                </Link>
                            </div>
                        )}
                    </div>

                    {/* Mobile menu button */}
                    <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden text-gray-300 hover:text-white p-2">
                        <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'} text-lg`}></i>
                    </button>
                </div>
            </div>

            {/* Mobile menu */}
            {menuOpen && (
                <div style={{ background: '#16213e' }} className="md:hidden border-t border-white/10">
                    <div className="px-4 py-3 space-y-1">
                        <Link to="/" onClick={() => setMenuOpen(false)} className="block px-3 py-2 text-gray-300 hover:text-white hover:bg-white/5 rounded-lg text-sm font-medium">Home</Link>
                        <Link to="/pricing" onClick={() => setMenuOpen(false)} className="block px-3 py-2 text-gray-300 hover:text-white hover:bg-white/5 rounded-lg text-sm font-medium">Pricing</Link>
                        {user ? (
                            <>
                                <Link to="/dashboard" onClick={() => setMenuOpen(false)} className="block px-3 py-2 text-gray-300 hover:text-white hover:bg-white/5 rounded-lg text-sm font-medium">Dashboard</Link>
                                <Link to="/reports" onClick={() => setMenuOpen(false)} className="block px-3 py-2 text-gray-300 hover:text-white hover:bg-white/5 rounded-lg text-sm font-medium">My Reports</Link>
                                <Link to="/billing" onClick={() => setMenuOpen(false)} className="block px-3 py-2 text-gray-300 hover:text-white hover:bg-white/5 rounded-lg text-sm font-medium">Billing</Link>
                                {user.email === 'boookssales@gmail.com' && (
                                    <Link to="/admin" onClick={() => setMenuOpen(false)} className="block px-3 py-2 font-bold rounded-lg text-sm text-white" style={{ background: '#e94560' }}>
                                        <i className="fas fa-shield-alt mr-1"></i> Admin Dashboard
                                    </Link>
                                )}
                                <button onClick={handleLogout} className="w-full text-left px-3 py-2 text-red-400 hover:text-red-300 hover:bg-white/5 rounded-lg text-sm font-medium">Logout</button>
                            </>
                        ) : (
                            <>
                                <Link to="/login" onClick={() => setMenuOpen(false)} className="block px-3 py-2 text-gray-300 hover:text-white hover:bg-white/5 rounded-lg text-sm font-medium">Login</Link>
                                <Link to="/register" onClick={() => setMenuOpen(false)} className="block px-3 py-2 text-white rounded-lg text-sm font-semibold mt-2" style={{ background: '#e94560' }}>Sign Up Free</Link>
                            </>
                        )}
                    </div>
                </div>
            )}
        </nav>
    );
}
